import React from "react";
import EmptyContent from "../../../../components/EmptyContent/EmptyContent";

export const EmptyCollaboratorsView = ({ setIsCollaboratorDrawerOpen, className }) => {
  return (
    <div className={`d-flex flex-column ${className || ''}`}>
      <EmptyContent label="Não encontramos nenhum colaborador" />
      <button
        onClick={() => setIsCollaboratorDrawerOpen(true)}
        className="btn br-6 bg-gradient-theme-blue text-white px-4 align-self-center mt-3"
      >
        Adicionar Colaborador
      </button>
    </div>
  );
};
